import { useEffect } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

export default function useSmoothScrollingPolyfill() {
	useEffect(() => {
		smoothscroll.polyfill();
	}, []);
}
